module.exports = __webpack_public_path__ + "info.png?4dcfb47436a0c71132741520f7192953";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/info.png
// module id = 53
// module chunks = 0